module.exports = __webpack_public_path__ + "images/feature/20150603_03-252febea2d5d41baa68f4df74be5c92e.png";